import { render, staticRenderFns } from "./ConfigDetailView.vue?vue&type=template&id=648e8f00"
import script from "./ConfigDetailView.vue?vue&type=script&lang=js"
export * from "./ConfigDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports